import { RadioGroup as R } from 'radix-ui';
import { type ReactNode, useId } from 'react';
import { cx } from '@/lib/cx';
import s from './Radio.module.css';

export function RadioGroup({
  value,
  onChange,
  options,
  orientation = 'vertical',
  className,
  ...aria
}: {
  value: string;
  onChange: (value: string) => void;
  options: { value: string; label: ReactNode; description?: ReactNode; disabled?: boolean }[];
  orientation?: 'vertical' | 'horizontal';
  className?: string;
  'aria-label'?: string;
}) {
  const base = useId();
  return (
    <R.Root value={value} onValueChange={onChange} orientation={orientation} className={cx(s.radioGroup, s[orientation], className)} {...aria}>
      {options.map((o) => (
        <span key={o.value} className={s.radioRow}>
          <R.Item id={`${base}-${o.value}`} value={o.value} disabled={o.disabled} className={s.radio}>
            <R.Indicator className={s.radioDot} />
          </R.Item>
          <label htmlFor={`${base}-${o.value}`} className={s.radioLabel}>
            <span className={s.label}>{o.label}</span>
            {o.description && <span className={s.description}>{o.description}</span>}
          </label>
        </span>
      ))}
    </R.Root>
  );
}
